export default "__VITE_ASSET__Ck1oh1at__"